export default "__VITE_ASSET__BQusHFun__"